import React, { useState, useContext } from "react";
import "./homereview.css";
import { MdKeyboardArrowLeft, MdKeyboardArrowRight } from "react-icons/md";
import { LanguageContext } from "../settings/LanguageContext";

const reviews = [
  { id: 1, name: "Alice", country: "USA", text: "Amazing service, highly recommend!" },
  { id: 2, name: "Tom", country: "UK", text: "Crazy fantastic, will do it again. Thanks for services!" },
  { id: 3, name: "Persie", country: "Canada", text: "People go ahead even for today!" },
  { id: 4, name: "John", country: "Portugal", text: "Love the driver, too kind!" },
  { id: 5, name: "Gago", country: "India", text: "Best people working here, best prices!" },
];

const Homereview = () => {
  const { lang } = useContext(LanguageContext);
  const [index, setIndex] = useState(0);

  const prev = () => setIndex((index - 1 + reviews.length) % reviews.length);
  const next = () => setIndex((index + 1) % reviews.length);

  const headings = {
    title: lang === "EN" ? "What our guests say about us" : "Что говорят наши гости",
    subtitle: lang === "EN" ? "Testimonials" : "Отзывы",
  };

  return (
    <div className="homereview-main">
      <div className="homereview-left">
        <h3 className="homereview-title">{headings.title}</h3>
        <p className="homereview-subtitle">{headings.subtitle}</p>
      </div>

      <div className="homereview-carousel">
        <button className="arrow left" onClick={prev}>
          <MdKeyboardArrowLeft />
        </button>

        <div className="carousel-wrapper">
          {reviews.map((review, i) => {
            let pos = i - index;
            if (pos < -Math.floor(reviews.length / 2)) pos += reviews.length;
            if (pos > Math.floor(reviews.length / 2)) pos -= reviews.length;

            return (
              <div
                key={review.id}
                className={`review-card ${pos === 0 ? "active" : pos < 0 ? "left" : "right"}`}
                style={{
                  transform: `translateX(${pos * 280}px) scale(${pos === 0 ? 1 : 0.8})`,
                  opacity: pos === 0 ? 1 : 0.5,
                  zIndex: pos === 0 ? 2 : 1,
                }}
              >
                <div className="review-header">
                  <div className="avatar">{review.name.charAt(0)}</div>
                  <div>
                    <h4 className="review-name">{review.name}</h4>
                    <p className="review-country">{review.country}</p>
                  </div>
                </div>
                <p className="review-text">"{review.text}"</p>
              </div>
            );
          })}
        </div>

        <button className="arrow right" onClick={next}>
          <MdKeyboardArrowRight />
        </button>
      </div>
    </div>
  );
};

export default Homereview;
